/*
 * @Author: LeeHuiXian
 * @version:
 * @Date: 2020-04-30 09:36:27
 * @LastEditors: LeeHuiXian
 * @LastEditTime: 2020-08-12 11:14:15
 * @FilePath: /goldenSalesMobile/src/api/pay.js
 * @Description: 支付相关api
 */
import { requestOfPost } from '../utils/http'
const baseUrl = 'wechath5/zh-cn/v1/'

// 微信支付
export function wxPay(param) {
  return requestOfPost(`${baseUrl}wechat/pay/jsapi`, param)
}

// 收钱吧支付-公众号支付
export function sqbWxPay(param) {
  return requestOfPost(`${baseUrl}shouqianba/wappay`, param)
}

// 收钱吧支付-H5支付
export function sqbH5Pay(param) {
  return requestOfPost(`${baseUrl}shouqianba/precreate`, param)
}
